import CustomerSearch from "../../components/customer-list/CustomerSearch";
import FabEyeButton from "../../components/user-activity-fab/UserActivityFab";

const CustomerLanding = () => {
  return (
    <>
      <CustomerSearch />
      <FabEyeButton />
      {/* <RecentProfiles /> */}
      {/* <QuickNotesFab /> */}
    </>
  );
};

export default CustomerLanding;
